
import magazines from '~/graphql/queries/magazines';
import page from '~/plugins/mixins/page';

export default {
  auth: false,
  mixins: [page],
  data: () => ({
    pageNumber: 1,
  }),
  apollo: {
    magazines: {
      query: magazines,
      variables: {
        limit: 24,
      },
    },
  },
  methods: {
    loadMore() {
      this.page++;
      this.$apollo.queries.magazines.fetchMore({
        variables: {
          page: this.pageNumber,
          limit: 8,
        },
        updateQuery: (previousResult, {fetchMoreResult}) => {
          const newMagazines = fetchMoreResult.magazines.data;
          const hasMorePages = fetchMoreResult.magazines.has_more_pages;
          this.showMoreEnabled = hasMorePages;
          return {
            magazines: {
              __typename: previousResult.magazines.__typename,
              data: [...previousResult.magazines.data, ...newMagazines],
              has_more_pages: hasMorePages,
              current_page: this.pageNumber,
              last_page: this.magazines.last_page,
            },
          };
        },
      });
    },
  },
};
